(function () {
  "use strict";

  var form       = document.getElementById("hiForm");
  var submitBtn  = document.getElementById("hiSubmitBtn");
  var btnText    = document.getElementById("hiBtnText");
  var btnLoader  = document.getElementById("hiBtnLoader");
  var successMsg = document.getElementById("hiSuccessMsg");
  var errorMsg   = document.getElementById("hiErrorMsg");

  var SHEET_URL = 'https://script.google.com/macros/s/AKfycbyyM2NcczWLY9o4AyupcoBVHYNYhbJjiVeycrs_gT5eswlsJ1U1tf-kCemgIVfVtfZ9_w/exec';

  /* ── Star Rating Logic ──────────────────────── */
  var ratings = {
    overall:    0,
    resolution: 0,
    behaviour:  0
  };

  var hiddenInputMap = {
    overall:    document.getElementById("hiOverall"),
    resolution: document.getElementById("hiResolution"),
    behaviour:  document.getElementById("hiBehaviour")
  };

  document.querySelectorAll(".hi-stars").forEach(function (starGroup) {
    var name  = starGroup.getAttribute("data-name");
    var stars = starGroup.querySelectorAll(".hi-star");

    stars.forEach(function (star) {
      var val = parseInt(star.getAttribute("data-value"), 10);

      // Hover — highlight up to hovered star
      star.addEventListener("mouseenter", function () {
        stars.forEach(function (s) {
          s.classList.remove("hovered");
          if (parseInt(s.getAttribute("data-value"), 10) <= val) {
            s.classList.add("hovered");
          }
        });
      });

      // Mouse leave — remove hover
      starGroup.addEventListener("mouseleave", function () {
        stars.forEach(function (s) {
          s.classList.remove("hovered");
        });
      });

      // Click — set rating
      star.addEventListener("click", function () {
        ratings[name] = val;
        hiddenInputMap[name].value = val;
        starGroup.classList.remove("hi-error");

        stars.forEach(function (s) {
          s.classList.remove("selected");
          if (parseInt(s.getAttribute("data-value"), 10) <= val) {
            s.classList.add("selected");
          }
        });
      });
    });
  });

  /* ── UTM Params ─────────────────────────────── */
  function getUTM() {
    var p = new URLSearchParams(window.location.search);
    return {
      utm_source:   p.get('utm_source')   ? '- ' + p.get('utm_source')   : '- utm_source',
      utm_medium:   p.get('utm_medium')   ? '- ' + p.get('utm_medium')   : '- utm_medium',
      utm_campaign: p.get('utm_campaign') ? '- ' + p.get('utm_campaign') : '- utm_campaign',
      gclid:        p.get('gclid')        ? '- ' + p.get('gclid')        : '- gclid'
    };
  }

  /* ── Loading State ───────────────────────────── */
  function setLoading(on) {
    submitBtn.disabled      = on;
    btnText.style.display   = on ? "none"         : "inline";
    btnLoader.style.display = on ? "inline-block" : "none";
  }

  /* ── Validation ──────────────────────────────── */
  function validate() {
    var ok = true;

    ["overall", "resolution", "behaviour"].forEach(function (key) {
      if (!ratings[key] || ratings[key] === 0) {
        var starGroup = document.querySelector('.hi-stars[data-name="' + key + '"]');
        if (starGroup) starGroup.classList.add("hi-error");
        ok = false;
      }
    });

    return ok;
  }

  /* ── Reset Form ──────────────────────────────── */
  function resetForm() {
    ratings = { overall: 0, resolution: 0, behaviour: 0 };

    Object.keys(hiddenInputMap).forEach(function (key) {
      hiddenInputMap[key].value = "";
    });

    document.querySelectorAll(".hi-star").forEach(function (s) {
      s.classList.remove("selected", "hovered");
    });

    document.getElementById("hiSuggestions").value = "";
  }

  /* ── Form Submit ─────────────────────────────── */
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    errorMsg.style.display   = "none";
    successMsg.style.display = "none";

    // Clear previous star errors
    document.querySelectorAll(".hi-stars").forEach(function (g) {
      g.classList.remove("hi-error");
    });

    if (!validate()) {
      errorMsg.textContent   = "❌ Please rate all required fields.";
      errorMsg.style.display = "block";
      return;
    }

    var suggestions = document.getElementById("hiSuggestions").value.trim();
    var utm = getUTM();

    setLoading(true);

    // ── Send to Google Sheet ──────────────
    fetch(SHEET_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        formName    : 'HelpImprove',
        overall     : ratings.overall + '/5',
        resolution  : ratings.resolution + '/5',
        behaviour   : ratings.behaviour + '/5',
        suggestions : suggestions || '',
        utm_source   : utm.utm_source,
        utm_medium   : utm.utm_medium,
        utm_campaign : utm.utm_campaign,
        gclid        : utm.gclid
      })
    })
      .then(function () {
        setLoading(false);
        resetForm();
        form.querySelectorAll(".hi-rating-row, .hi-suggestions-row, .hi-btn-row").forEach(function (el) {
          el.style.display = "none";
        });
        successMsg.style.display = "block";
      })
      .catch(function (err) {
        console.error("Submit Error:", err);
        setLoading(false);
        errorMsg.textContent   = "❌ Something went wrong. Please try again.";
        errorMsg.style.display = "block";
      });

    });

})();